import { Routes, Route, Navigate } from 'react-router-dom';
import { SignupPage } from './pages/SignupPage.jsx';
import { SignupPendingPage } from './pages/SignupPendingPage.jsx';
import { VerifyPage } from './pages/VerifyPage.jsx';
import { LoginPage } from './pages/LoginPage.jsx';
import { DashboardShell } from './pages/DashboardShell.jsx';
import { StaffPage } from './pages/dashboard/StaffPage.jsx';
import { StaffEditor } from './pages/dashboard/StaffEditor.jsx';
import { ScansPage } from './pages/dashboard/ScansPage.jsx';
import { BrandingPage } from './pages/dashboard/BrandingPage.jsx';
import { SettingsLayout } from './pages/dashboard/settings/SettingsLayout.jsx';
import { OrganisationPage } from './pages/dashboard/settings/OrganisationPage.jsx';
import { TeamPage } from './pages/dashboard/settings/TeamPage.jsx';
import { SecurityPage } from './pages/dashboard/settings/SecurityPage.jsx';
import { BillingPage } from './pages/dashboard/settings/BillingPage.jsx';
import { DangerZonePage } from './pages/dashboard/settings/DangerZonePage.jsx';
import { IdCardsPage } from './pages/dashboard/settings/IdCardsPage.jsx';
import { VerifyPublicPage } from './pages/public/VerifyPublicPage.jsx';
import { ProtectedRoute } from './components/ProtectedRoute.jsx';

/**
 * Chunk 2D route updates:
 *   /dashboard/settings               → SettingsLayout with Outlet
 *     index                           → Navigate to /dashboard/settings/organisation
 *     organisation                    → OrganisationPage
 *     team                            → TeamPage
 *     security                        → SecurityPage
 *     billing                         → BillingPage
 *     danger                          → DangerZonePage
 *
 * The old ComingSoonPage route for /dashboard/settings is replaced
 * with the real SettingsLayout + nested children.
 */
export function App() {
  return (
    <Routes>
      {/* ─── Public ─── */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/signup/pending" element={<SignupPendingPage />} />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* ─── Public verify page ─── */}
      <Route path="/v/:tenantSlug/:staffSlug" element={<VerifyPublicPage />} />

      {/* ─── Dashboard (authenticated) ─── */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard/staff" replace />} />

        {/* Staff */}
        <Route path="staff" element={<StaffPage />} />
        <Route path="staff/new" element={<StaffEditor />} />
        <Route path="staff/:id" element={<StaffEditor />} />

        {/* Scans + Branding */}
        <Route path="scans" element={<ScansPage />} />
        <Route path="branding" element={<BrandingPage />} />

        {/* Settings — NEW in Chunk 2D */}
        <Route path="settings" element={<SettingsLayout />}>
          <Route index element={<Navigate to="/dashboard/settings/organisation" replace />} />
          <Route path="organisation" element={<OrganisationPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="id-cards" element={<IdCardsPage />} />
          <Route path="danger" element={<DangerZonePage />} />
          <Route path="*" element={<Navigate to="/dashboard/settings/organisation" replace />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard/staff" replace />} />
      </Route>

      <Route path="*" element={<Navigate to="/signup" replace />} />
    </Routes>
  );
}
